// third-party
import { createSlice } from '@reduxjs/toolkit';

// project imports
import axios from 'utils/axios';
import { dispatch } from '../index';

// ----------------------------------------------------------------------

const initialState = {
    error: null,
    subindustry: {},
    subindustries: [],
    count: 0,
};

const slice = createSlice({
    name: 'subindustry',
    initialState,
    reducers: {
        // HAS ERROR
        hasError(state, action) {
            state.error = action.payload;
        },

        // GET SUBINDUSTRYS
        getSubindustriesSuccess(state, action) {
            state.subindustries = action.payload.subindustryList;
            state.count = action.payload.total;
        },

        // GET SUBINDUSTRY
        getSubindustrySuccess(state, action) {
            state.subindustry = action.payload;
        }
    }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getSubindustries(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/subindustry/list', data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
            );
            dispatch(slice.actions.getSubindustriesSuccess(response.data));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function addSubindustry(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/subindustry/add', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            }
            );
            if(callback){
                callback(response.data.subindustry.id);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getSubindustry(id, callback) {
    return async () => {
        try {
            const response = await axios.get('/api/subindustry/details/'+id, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getSubindustrySuccess(response.data.subindustry));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function updateSubindustry(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/subindustry/edit', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getSubindustrySuccess(response.data.subindustry));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}